import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


const DateFilter = (props) => {
  const filterNameFrom = `${props.name}_from`;
  const filterNameThrough = `${props.name}_to`;

  const dateFromClass = props.validationErrorsFields.includes(filterNameFrom)
    ? 'date-picker validation-error'
    : 'date-picker';

  const dateThroughClass = props.validationErrorsFields.includes(filterNameThrough)
    ? 'date-picker validation-error'
    : 'date-picker';

  return (
    <div>
      <div className="date-picker-container">
        <label className="date-picker-label">
          Date {props.name} from:
        </label>
        <DatePicker selected={props.filters.get(filterNameFrom)}
                    onChange={date => props.onChange({ [filterNameFrom]: date })}
                    dateFormat="MM/DD/YYYY"
                    className={dateFromClass} />
      </div>
      <div className="date-picker-container">
        <label className="date-picker-label">
          through:
        </label>
        <DatePicker selected={props.filters.get(filterNameThrough)}
                    onChange={date => props.onChange({ [filterNameThrough]: date })}
                    dateFormat="MM/DD/YYYY"
                    className={dateThroughClass} />
      </div>
    </div>
  );
};

DateFilter.defaultProps = {
  validationErrorsFields: '',
  name: '',
};

DateFilter.propTypes = {
  validationErrorsFields: PropTypes.string,
  name: PropTypes.string,
  filters: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  validationErrorsFields: state.getIn(['validationErrors', 'fields'], []),
});

export default connect(mapStateToProps)(DateFilter);



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/dateFilter/DateFilter.js
 **/